import _extends from "@babel/runtime/helpers/esm/extends";

/**
 * @file 操作列下拉组件
 * @author malcolmmzma
 */
import React from 'react';
import _ from 'lodash';
import { Icon, Dropdown, DropdownToggle, DropdownContent } from '@tencent/spaui';
import classnames from 'classnames';
export default (function (props) {
  var title = props.title,
      tableInfo = props.tableInfo,
      options = props.options,
      labelProps = props.labelProps,
      actionHandler = props.actionHandler;

  var dropDownItems = _.map(_.compact(options), function (option) {
    return actionHandler(tableInfo, option);
  });

  return /*#__PURE__*/React.createElement(Dropdown, {
    placement: "left",
    alignment: "top",
    offsetData: {
      top: -16
    }
  }, /*#__PURE__*/React.createElement(DropdownToggle, null, /*#__PURE__*/React.createElement("a", _extends({}, labelProps, {
    className: classnames('table-operation', labelProps === null || labelProps === void 0 ? void 0 : labelProps.className),
    onClick: function onClick(event) {
      event.stopPropagation();
    }
  }), title, /*#__PURE__*/React.createElement(Icon, {
    name: "dropdown-arrow-outlined",
    className: "down-arrow"
  }))), /*#__PURE__*/React.createElement(DropdownContent, {
    className: "table-operation__dropdown-content"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "table-operation-submenu spaui-submenu"
  }, _.map(dropDownItems, function (item, index) {
    return /*#__PURE__*/React.createElement("li", {
      className: "spaui-menuitem",
      key: index
    }, item);
  }))));
});